import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePropertyContactByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Property_Contacts_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdatePropertyContactByIdMutation = { __typename?: 'mutation_root', update_property_contacts_by_pk?: { __typename?: 'property_contacts', id: any, name?: string | null, number?: string | null, email?: string | null } | null };


export const UpdatePropertyContactByIdDocument = gql`
    mutation updatePropertyContactById($set: property_contacts_set_input, $id: uuid!) {
  update_property_contacts_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    name
    number
    email
  }
}
    `;
export type UpdatePropertyContactByIdMutationFn = Apollo.MutationFunction<UpdatePropertyContactByIdMutation, UpdatePropertyContactByIdMutationVariables>;

/**
 * __useUpdatePropertyContactByIdMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyContactByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyContactByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyContactByIdMutation, { data, loading, error }] = useUpdatePropertyContactByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePropertyContactByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyContactByIdMutation, UpdatePropertyContactByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyContactByIdMutation, UpdatePropertyContactByIdMutationVariables>(UpdatePropertyContactByIdDocument, options);
      }
export type UpdatePropertyContactByIdMutationHookResult = ReturnType<typeof useUpdatePropertyContactByIdMutation>;
export type UpdatePropertyContactByIdMutationResult = Apollo.MutationResult<UpdatePropertyContactByIdMutation>;
export type UpdatePropertyContactByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyContactByIdMutation, UpdatePropertyContactByIdMutationVariables>;